import axios from "axios";
import url from "../../config/url";
import _ from "lodash";
import settings from "../../config/settings";
import moment from "moment";

const state = {
    reportAggregate: [],
    //========= bench overview ========//
    benchRelations: [],
    benchAllocations: [],
    metadata: {},
    filter: {
        // bench filter
        pageNumber: 1,
        pageSize: 25,
        previousMonthsCount: settings.bench_overview_previous_month_count,
        futureMonthsCount: settings.bench_overview_future_month_count,
        filterParams: [],
        sortColumn: "",
        sortOrder: "",
        from: moment()
            .startOf("month")
            .format("MM-YYYY"),
        to: moment()
            .add(3, "M")
            .startOf("month")
            .format("MM-YYYY"),
        EngagementRange: 100
    },
    loadingMoreBenchRows: false,
    // For report header filter
    MonthChanged: false,
    //========= customer turnover ========//
    customerTurnoverRelations: [],
    customerTurnoverAllocations: [],
    customerTurnoverResult: [],
    customerTurnoverFilter: {
        pageNumber: 1,
        pageSize: 25,
        previousMonthsCount: settings.previous_month_count,
        futureMonthsCount: settings.future_month_count,
        filterParams: [],
        sortColumn: "",
        sortOrder: ""
    },
    loadingCustomerTurnoverRows: false,
    //========= customer engagement ==========//
    customerEngagementRelations: [],
    customerEngagementAllocations: [],
    customerEngagementResult: [],
    customerEngagementMetadata: {},
    customerEngagementFilter: {
        pageNumber: 1,
        pageSize: 25,
        previousMonthsCount: settings.previous_month_count,
        futureMonthsCount: settings.future_month_count,
        filterParams: [],
        sortColumn: "",
        sortOrder: ""
    },
    loadingCustomerEngagementRows: false,
    isEngagementFetchFinished: false,
    //======== consultant workload ===========//
    consultantWorkloadRelations: [],
    consultantWorkloadAllocations: [],
    consultantWorkloadResult: [],
    consultantWorkloadMetadata: {},
    consultantWorkloadFilter: {
        pageNumber: 1,
        pageSize: 25,
        previousMonthsCount: settings.previous_month_count,
        futureMonthsCount: settings.future_month_count,
        filterParams: [],
        sortColumn: "",
        sortOrder: ""
    },
    loadingConsultantWorkloadRows: false,
    //======== qcenti ===========//
    qcentrisUnitTurnoverRelations: [],
    qcentrisUnitTurnoverAllocations: [],
    qcentrisUnitTurnoverResult: [],
    qcentrisUnitTurnoverFilter: {
        pageNumber: 1,
        pageSize: 25,
        previousMonthsCount: settings.previous_month_count,
        futureMonthsCount: settings.future_month_count,
        filterParams: [],
        sortColumn: "",
        sortOrder: ""
    },
    loadingQcentrisUnitTurnoverRows: false,
    //======== qcentis country ===========//
    qcentrisCountryTurnoverRelations: [],
    qcentrisCountryTurnoverAllocations: [],
    qcentrisCountryTurnoverResult: [],
    qcentrisCountryTurnoverFilter: {
        pageNumber: 1,
        pageSize: 25,
        previousMonthsCount: settings.previous_month_count,
        futureMonthsCount: settings.future_month_count,
        filterParams: [],
        sortColumn: "",
        sortOrder: ""
    }
};
const mutations = {
    /**
     * Set data to store
     * @param state
     * @param data
     */
    setBenchReports: (state, data) => {
        state.benchRelations = Object.freeze(data.consultantsInBench);
        state.benchAllocations = Object.freeze(
            data.benchEngangementInMonthAndYearModels
        );
        state.metadata = Object.freeze(data.thresholds);
    },
    /**
     * Increment bench overview filter data
     * @param state
     */
    updateCustomerEngagementFilter: state => {
        let filter = _.cloneDeep(state.customerEngagementFilter);
        filter.pageNumber++;
        state.customerEngagementFilter = filter;
    },
    /**
     * Update bench overview data on fetching more
     * @param state
     * @param data
     */
    // updateBenchOverviewData: (state, data) => {
    //     if (data.consultantsInBench && data.consultantsInBench.length > 0) {
    //         let benchRelation = _.cloneDeep(state.benchRelations);
    //         let benchAllocations = _.cloneDeep(state.benchAllocations);
    //         benchRelation = [...benchRelation, ...data.consultantsInBench];
    //         data.benchEngangementInMonthAndYearModels.forEach(
    //             (benchAllocation, benchAllocationIndex) => {
    //                 benchAllocations[benchAllocationIndex].benchOverviewEngangements = [
    //                     ...benchAllocations[benchAllocationIndex].benchOverviewEngangements,
    //                     ...benchAllocation.benchOverviewEngangements
    //                 ];
    //             }
    //         );
    //         state.benchRelations = benchRelation;
    //         state.benchAllocations = benchAllocations;
    //     }
    // },
    setBenchFromDate: (state, value) => {
        let filter = _.cloneDeep(state.filter);
        filter.from = value;
        state.filter = filter;
    },
    setBenchToDate: (state, value) => {
        let filter = _.cloneDeep(state.filter);
        filter.to = value;
        state.filter = filter;
    },
    setBenchEngangementRange: (state, value) => {
        let filter = _.cloneDeep(state.filter);
        filter.EngagementRange = value;
        state.filter = filter;
    },
    // set flag on loading more data
    setBenchLoader: (state, value) => state.loadingMoreBenchRows = value,
    /**
     * Set search data for bench report
     * @param state
     * @param data
     */
    setBenchSearchData: (state, data) => {
        // clone the filter
        let filter = _.cloneDeep(state.filter);
        // get the current filter by matching the field name
        let currentFilterObject = filter.filterParams.find(
            f => f.fieldName === data.key
        );
        // if the current filter already exists
        if (currentFilterObject) {
            // update the value if the new value is not null
            if (data.value) {
                currentFilterObject.value = data.value;
            } else {
                // remove the search entry if already exists and the value is null
                let index = filter.filterParams.indexOf(currentFilterObject);
                filter.filterParams.splice(index, 1);
            }
        } else {
            // if no filter object is find and the value is not null, create new object
            if (data.value) {
                let currentFilter = {
                    fieldName: data.key,
                    value: data.value
                };
                // push object into filter array
                filter.filterParams.push(currentFilter);
            }
        }
        // since the search will affect the whole rows, init the page number and search
        filter.pageNumber = 1;
        // set back the filter
        state.filter = Object.freeze(filter);
    },
    /**
     * Set search data for customer turnover
     * @param state
     * @param data
     */
    setCustomerTurnoverSearchData: (state, data) => {
        // clone the filter
        let filter = _.cloneDeep(state.customerTurnoverFilter);
        // get the current filter by matching the field name
        let currentFilterObject = filter.filterParams.find(
            f => f.fieldName === data.key
        );
        // if the current filter already exists
        if (currentFilterObject) {
            // update the value if the new value is not null
            if (data.value) {
                currentFilterObject.value = data.value;
            } else {
                // remove the search entry if already exists and the value is null
                let index = filter.filterParams.indexOf(currentFilterObject);
                filter.filterParams.splice(index, 1);
            }
        } else {
            // if no filter object is find and the value is not null, create new object
            if (data.value) {
                let currentFilter = {
                    fieldName: data.key,
                    value: data.value
                };
                // push object into filter array
                filter.filterParams.push(currentFilter);
            }
        }
        // since the search will affect the whole rows, init the page number and search
        filter.pageNumber = 1;
        // set back the filter
        state.customerTurnoverFilter = Object.freeze(filter);
    },
    /**
     * Set data for the customer engagement report
     * @param state
     * @param data
     */
    setCustomerEngagementSearchData: (state, data) => {
        // clone the filter
        let filter = _.cloneDeep(state.customerEngagementFilter);
        // get the current filter by matching the field name
        let currentFilterObject = filter.filterParams.find(
            f => f.fieldName === data.key
        );
        // if the current filter already exists
        if (currentFilterObject) {
            // update the value if the new value is not null
            if (data.value) {
                currentFilterObject.value = data.value;
            } else {
                // remove the search entry if already exists and the value is null
                let index = filter.filterParams.indexOf(currentFilterObject);
                filter.filterParams.splice(index, 1);
            }
        } else {
            // if no filter object is find and the value is not null, create new object
            if (data.value) {
                let currentFilter = {
                    fieldName: data.key,
                    value: data.value
                };
                // push object into filter array
                filter.filterParams.push(currentFilter);
            }
        }
        // since the search will affect the whole rows, init the page number and search
        filter.pageNumber = 1;
        // set back the filter
        state.customerEngagementFilter = Object.freeze(filter);
    },
    /**
     * Set search data for consultant workload
     * @param state
     * @param data
     */
    setConsultantWorkloadSearchData: (state, data) => {
        // clone the filter
        let filter = _.cloneDeep(state.consultantWorkloadFilter);
        // get the current filter by matching the field name
        let currentFilterObject = filter.filterParams.find(
            f => f.fieldName === data.key
        );
        // if the current filter already exists
        if (currentFilterObject) {
            // update the value if the new value is not null
            if (data.value) {
                currentFilterObject.value = data.value;
            } else {
                // remove the search entry if already exists and the value is null
                let index = filter.filterParams.indexOf(currentFilterObject);
                filter.filterParams.splice(index, 1);
            }
        } else {
            // if no filter object is find and the value is not null, create new object
            if (data.value) {
                let currentFilter = {
                    fieldName: data.key,
                    value: data.value
                };
                // push object into filter array
                filter.filterParams.push(currentFilter);
            }
        }
        // since the search will affect the whole rows, init the page number and search
        filter.pageNumber = 1;
        // set back the filter
        state.consultantWorkloadFilter = Object.freeze(filter);
    },
    setCountryTurnoverSearchData: (state, data) => {
        // clone the filter
        let filter = _.cloneDeep(state.qcentrisCountryTurnoverFilter);
        // get the current filter by matching the field name
        let currentFilterObject = filter.filterParams.find(
            f => f.fieldName === data.key
        );
        // if the current filter already exists
        if (currentFilterObject) {
            // update the value if the new value is not null
            if (data.value) {
                currentFilterObject.value = data.value;
            } else {
                // remove the search entry if already exists and the value is null
                let index = filter.filterParams.indexOf(currentFilterObject);
                filter.filterParams.splice(index, 1);
            }
        } else {
            // if no filter object is find and the value is not null, create new object
            if (data.value) {
                let currentFilter = {
                    fieldName: data.key,
                    value: data.value
                };
                // push object into filter array
                filter.filterParams.push(currentFilter);
            }
        }
        // since the search will affect the whole rows, init the page number and search
        filter.pageNumber = 1;
        // set back the filter
        state.qcentrisCountryTurnoverFilter = Object.freeze(filter);
    },
    setUnitTurnoverSearchData: (state, data) => {
        // clone the filter
        let filter = _.cloneDeep(state.qcentrisUnitTurnoverFilter);
        // get the current filter by matching the field name
        let currentFilterObject = filter.filterParams.find(
            f => f.fieldName === data.key
        );
        // if the current filter already exists
        if (currentFilterObject) {
            // update the value if the new value is not null
            if (data.value) {
                currentFilterObject.value = data.value;
            } else {
                // remove the search entry if already exists and the value is null
                let index = filter.filterParams.indexOf(currentFilterObject);
                filter.filterParams.splice(index, 1);
            }
        } else {
            // if no filter object is find and the value is not null, create new object
            if (data.value) {
                let currentFilter = {
                    fieldName: data.key,
                    value: data.value
                };
                // push object into filter array
                filter.filterParams.push(currentFilter);
            }
        }
        // since the search will affect the whole rows, init the page number and search
        filter.pageNumber = 1;
        // set back the filter
        state.qcentrisUnitTurnoverFilter = Object.freeze(filter);
    },
    /**
     * Set sort value for bench overview
     * @param state
     * @param data
     */
    setBenchSort: (state, data) => {
        let filter = _.cloneDeep(state.filter);
        filter.sortColumn = data.column;
        filter.sortOrder = data.order;
        state.filter = filter;
    },
    /**
     * Set sort value for customer engagement
     * @param state
     * @param data
     */
    setCustomerEngagementSort: (state, data) => {
        let customerEngagementFilter = _.cloneDeep(state.customerEngagementFilter);
        customerEngagementFilter.sortColumn = data.column;
        customerEngagementFilter.sortOrder = data.order;
        state.customerEngagementFilter = customerEngagementFilter;
    },
    /**
     * Set sort value for customer turnover
     * @param state
     * @param data
     */
    setCustomerTurnoverSort: (state, data) => {
        let customerTurnoverFilter = _.cloneDeep(state.customerTurnoverFilter);
        customerTurnoverFilter.sortColumn = data.column;
        customerTurnoverFilter.sortOrder = data.order;
        state.customerTurnoverFilter = customerTurnoverFilter;
    },
    /**
     * Set sort value for consultant workload
     * @param state
     * @param data
     */
    setConsultantWorkloadSearch: (state, data) => {
        let consultantWorkloadFilter = _.cloneDeep(state.consultantWorkloadFilter);
        consultantWorkloadFilter.sortColumn = data.column;
        consultantWorkloadFilter.sortOrder = data.order;
        state.consultantWorkloadFilter = consultantWorkloadFilter;
    },
    /**
     * Set sort value for qcentris unit turnover
     * @param state
     * @param data
     */
    setQcentrisTurnoverSort: (state, data) => {
        let qcentrisUnitTurnoverFilter = _.cloneDeep(state.qcentrisUnitTurnoverFilter);
        qcentrisUnitTurnoverFilter.sortColumn = data.column;
        qcentrisUnitTurnoverFilter.sortOrder = data.order;
        state.qcentrisUnitTurnoverFilter = qcentrisUnitTurnoverFilter;
    },
    /**
     * Set sort data for country report
     * @param state
     * @param data
     */
    setCountrySort: (state, data) => {
        let qcentrisCountryTurnoverFilter = _.cloneDeep(state.qcentrisCountryTurnoverFilter);
        qcentrisCountryTurnoverFilter.sortColumn = data.column;
        qcentrisCountryTurnoverFilter.sortOrder = data.order;
        state.qcentrisCountryTurnoverFilter = qcentrisCountryTurnoverFilter;
    },
    // set the flag value on loading data
    isLoadingCustomerTurnoverRows: (state, value) =>
        (state.loadingCustomerTurnoverRows = value),
    /**
     * Set initial data for customer turn over report
     * @param state
     * @param data
     */
    setCustomerTurnover: (state, data) => {
        state.customerTurnoverRelations = Object.freeze(data.customers);
        state.customerTurnoverAllocations = Object.freeze(data.customerTurnovers);
        state.customerTurnoverResult = Object.freeze(data.customerTurnAggregates);
    },
    /**
     * Set customer engagement initial data
     * @param state
     * @param data
     */
    setCustomerEngagement: (state, data) => {
        state.customerEngagementRelations = Object.freeze(data.customerEngagementRelations);
        state.customerEngagementAllocations = Object.freeze(data.customerEngagementMonthAndYear);
        state.customerEngagementResult = Object.freeze(data.customerEngagementAggregates);
        state.customerEngagementMetadata = Object.freeze(data.metaData);
    },
    /**
     * Update customer engagement data on rolling down
     * @param state
     * @param data
     */
    updateCustomerEngagementData: (state, data) => {
        if (data.customerEngagementRelations && data.customerEngagementRelations.length > 0) {
            let customerEngagementRelations = _.cloneDeep(state.customerEngagementRelations);
            let customerEngagementAllocations = _.cloneDeep(state.customerEngagementAllocations);
            customerEngagementRelations = [...customerEngagementRelations, ...data.customerEngagementRelations];
            data.customerEngagementMonthAndYear.forEach((customerEngagementAllocation, allocationIndex) => {
                    customerEngagementAllocations[allocationIndex].customerEngagementMonthlyAllocations = [
                        ...customerEngagementAllocations[allocationIndex].customerEngagementMonthlyAllocations,
                        ...customerEngagementAllocation.customerEngagementMonthlyAllocations
                    ];
                }
            );
            state.customerEngagementRelations = customerEngagementRelations;
            state.customerEngagementAllocations = customerEngagementAllocations;
        } else {
            state.isEngagementFetchFinished = true;
        }
    },
    setEngagementFetchFlag: (state, count) => {
        state.isEngagementFetchFinished = state.customerEngagementRelations.length >= count;
    },
    // set flag value for loading customer engagement data
    setCustomerEngagementLoader: (state, value) => state.loadingCustomerEngagementRows = value,
    /**
     * set unit turnover initial data
     * @param state
     * @param data
     */
    setQcentrisUnitTurnover: (state, data) => {
        state.qcentrisUnitTurnoverRelations = Object.freeze(data.units);
        state.qcentrisUnitTurnoverAllocations = Object.freeze(data.unitTurnOvers);
    },
    // set report aggregates
    setReportAggregate: (state, data) => (state.reportAggregate = data),
    /**
     * Set data to country turn over
     * @param state
     * @param data
     */
    setQcentrisCountryTurnover: (state, data) => {
        state.qcentrisCountryTurnoverAllocations = data.countriesTurnOvers;
        state.qcentrisCountryTurnoverRelations = data.countries;
    },
    /**
     * Set consultant workload data
     * @param state
     * @param data
     */
    setConsultantWorkload: (state, data) => {
        state.consultantWorkloadAllocations = data.consultantsEngagementsInMonthAndYearList;
        state.consultantWorkloadRelations = data.consultantsList;
        state.consultantWorkloadMetadata = Object.freeze(data.thresholds);
    },
    /**
     * Set workload aggregate
     * Using seperate aggregate for workload
     * @param state
     * @param data
     */
    setWorkloadAggregate: (state, data) => {
        state.consultantWorkloadResult = data;
    }
};
const actions = {
    /**
     * Fetch the initial data for bench overview
     * @param commit
     * @param filter
     * @returns {Promise<unknown>}
     */
    fetchBenchReport: function ({commit}, filter) {
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios
                .post(url.bench_report_api, filter)
                .then(response => {
                    if (response.data.status) {
                        commit("setBenchReports", response.data.responseObject);
                        resolve(response);
                    } else {
                        reject(response);
                    }
                    commit("setGlobalLoader", false);
                })
                .catch(() => {
                    reject();
                    commit("setGlobalLoader", false);
                });
        });
    },
    /**
     * Fetch more data for bench overview
     * @param commit
     * @param state
     * @returns {Promise<unknown>}
     */
    // fetchMoreBenchReport: function ({commit, state}) {
    //     // update the filter page count
    //     commit("updateBenchOverviewFilter");
    //     return new Promise((resolve, reject) => {
    //         commit("setBenchLoader", true);
    //         axios
    //             .post(url.bench_report_api, state.filter)
    //             .then(response => {
    //                 if (response.data.status) {
    //                     commit("updateBenchOverviewData", response.data.responseObject);
    //                     resolve();
    //                 } else {
    //                     reject();
    //                 }
    //                 commit("setBenchLoader", false);
    //             })
    //             .catch(() => {
    //                 commit("setBenchLoader", false);
    //                 reject();
    //             });
    //     });
    // },
    /**
     * Fetch customer turn over report
     * @param commit
     * @param filter
     * @returns {Promise<unknown>}
     */
    fetchCustomerTurnoverReport: function ({commit}, filter) {
        commit("isLoadingCustomerTurnoverRows", true);
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios
                .post(url.customer_turnover_report_api, filter)
                .then(response => {
                    if (response.data.status) {
                        commit("setCustomerTurnover", response.data.responseObject);
                        commit("setGlobalLoader", false);
                        resolve(response);
                    } else {
                        commit("setGlobalLoader", false);
                        reject(response);
                    }
                    commit("isLoadingCustomerTurnoverRows", false);
                })
                .catch(() => {
                    commit("isLoadingCustomerTurnoverRows", false);
                    commit("setGlobalLoader", false);
                    reject();
                });
        });
    },
    /**
     * Fetch customer engagement data
     * @param commit
     * @param filter
     * @returns {Promise<unknown>}
     */
    fetchCustomerEngagementReport: function ({commit}, filter) {
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios
                .post(url.customer_engagement_report_api, filter)
                .then(response => {
                    if (response.data && response.data.status) {
                        commit("setCustomerEngagement", response.data.responseObject);
                        commit("setGlobalLoader", false);
                        resolve(response);
                    } else {
                        commit("setGlobalLoader", false);
                        reject(false);
                    }
                })
                .catch(() => {
                    commit("setGlobalLoader", false);
                    reject(false);
                });
        });
    },
    fetchMoreCustomerEngagement: function ({commit, state}) {
        if (!state.isEngagementFetchFinished) {
            // update the filter page count
            commit("updateCustomerEngagementFilter");
            return new Promise((resolve, reject) => {
                commit("setCustomerEngagementLoader", true);
                axios
                    .post(url.customer_engagement_report_api, state.customerEngagementFilter)
                    .then(response => {
                        if (response.data.status) {
                            commit("updateCustomerEngagementData", response.data.responseObject);
                            commit("setEngagementFetchFlag", response.data.responseObject.listCount);
                            resolve();
                        } else {
                            reject();
                        }
                        commit("setCustomerEngagementLoader", false);
                    })
                    .catch(() => {
                        commit("setCustomerEngagementLoader", false);
                        reject();
                    });
            });
        }
    },
    /**
     * Fetch consultant workload
     * @param commit
     * @param filter
     * @returns {Promise<unknown>}
     */
    fetchConsultantWorkload: function ({commit}, filter) {
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios.post(url.costusltant_workload_api, filter)
                .then(
                    response => {
                        if (response.data && response.data.status) {
                            commit('setConsultantWorkload', response.data.responseObject)
                            commit("setGlobalLoader", false);
                            resolve(response);
                        } else {
                            commit("setGlobalLoader", false);
                            reject(false);
                        }
                    }
                )
                .catch(
                    () => {
                        commit("setGlobalLoader", false);
                        reject(false);
                    }
                )
        })
    },
    /**
     * Fetch workload
     * @param commit
     * @returns {Promise<unknown>}
     */
    fetchConsultantWorkloadAggregate: function ({commit}, filter) {
        return new Promise((resolve, reject) => {
            axios.post(url.costusltant_workload_aggregate_api, filter)
                .then(
                    response => {
                        if (response.data && response.data.status) {
                            commit('setWorkloadAggregate', response.data.responseObject);
                            resolve(response);
                        } else {
                            reject(false);
                        }
                    }
                )
                .catch(
                    () => {
                        reject(false);
                    }
                )
        })
    },
    /**
     * Fetch Qcentris unit turnover data
     * @param commit
     * @param filter
     * @returns {Promise<unknown>}
     */
    fetchQcentrisUnitTurnover: function ({commit}, filter) {
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios
                .post(url.qcentris_unit_turnover_api, filter)
                .then(response => {
                    if (response.data && response.data.status) {
                        commit("setQcentrisUnitTurnover", response.data.responseObject);
                        commit("setGlobalLoader", false);
                        resolve(response);
                    } else {
                        commit("setGlobalLoader", false);
                        reject(false);
                    }
                })
                .catch(() => {
                    commit("setGlobalLoader", false);
                    reject(false);
                });
        });
    },
    /**/
    exportBench: function ({commit}, filter) {
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios
                .post(url.reports_export_bench_api, filter, {responseType: "blob"})
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Benchoverview.xlsx"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    commit("setBenchReports", response.data.responseObject);
                    commit("setGlobalLoader", false);
                    resolve(response);
                })
                .catch(() => {
                    commit("setGlobalLoader", false);
                    reject();
                });
        });
    },
    exportCustomerEngagement: function ({commit}, filter) {
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios
                .post(url.reports_export_customer_engagement_api, filter, {
                    responseType: "blob"
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Customerengangement.xlsx"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    commit("setCustomerEngagement", response.data.responseObject);
                    commit("setGlobalLoader", false);
                    resolve(response);
                })
                .catch(() => {
                    commit("setGlobalLoader", false);
                    reject();
                });
        });
    },
    exportCustomerTurnover: function ({commit}, filter) {
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios
                .post(url.reports_export_customer_turnover_api, filter, {
                    responseType: "blob"
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Customerturnovers.xlsx"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    commit("setCustomerTurnover", response.data.responseObject);
                    commit("setGlobalLoader", false);
                    resolve(response);
                })
                .catch(() => {
                    commit("setGlobalLoader", false);
                    reject();
                });
        });
    },
    exportCountryTurnover: function ({commit}, filter) {
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios
                .post(url.reports_export_country_turnover_api, filter, {
                    responseType: "blob"
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Countryturnovers.xlsx"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    commit("setQcentrisCountryTurnover", response.data.responseObject);
                    commit("setGlobalLoader", false);
                    resolve(response);
                })
                .catch(() => {
                    commit("setGlobalLoader", false);
                    reject();
                });
        });
    },
    exportUnitTurnover: function ({commit}, filter) {
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios
                .post(url.reports_export_unit_turnover_api, filter, {
                    responseType: "blob"
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Unitturnovers.xlsx"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    commit("setQcentrisUnitTurnover", response.data.responseObject);
                    commit("setGlobalLoader", false);
                    resolve(response);
                })
                .catch(() => {
                    commit("setGlobalLoader", false);
                    reject();
                });
        });
    },
    exportConsultantworkload: function ({commit}, filter) {
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios
                .post(url.reports_export_consultant_workload_api, filter, {
                    responseType: "blob"
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Consultantworkload.xlsx"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    commit("setConsultantWorkload", response.data.responseObject);
                    commit("setGlobalLoader", false);
                    resolve(response);
                })
                .catch(() => {
                    commit("setGlobalLoader", false);
                    reject();
                });
        });
    },
    /**
     * Forecast result data is using for all the aggregates showing in reports sections
     * Fetch the reports results
     * @param commit
     * @param state
     * @param filter
     * @returns {Promise<unknown>}
     */
    fetchReportAggregates: function ({commit, state}, filter) {
        return new Promise((resolve, reject) => {
            axios
                .post(url.report_result, filter)
                .then(response => {
                    if (response.data.status) {
                        // set the data into store
                        commit("setReportAggregate", response.data.responseObject);
                        resolve(response);
                    }
                })
                .catch(reason => reject(reason));
        });
    },
    /**
     * Fetch qcentris country turnover data
     * @param commit
     * @param filter
     */
    fetchCountryTurnover: function ({commit}, filter) {
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios.post(url.qcentris_country_turnover_api, filter)
                .then(response => {
                    if (response.data && response.data.status) {
                        commit('setQcentrisCountryTurnover', response.data.responseObject);
                        commit("setGlobalLoader", false);
                        resolve(response);
                    } else {
                        commit("setGlobalLoader", false);
                        reject(false);
                    }

                })
                .catch(() => {
                    commit("setGlobalLoader", false);
                    reject(false);
                });
        });
    }
};
export default {
    state,
    mutations,
    actions
};
